import React, { useState } from 'react';
import {
  Card,
  CardBody,
  Col,
  Row,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Alert,
} from 'reactstrap';
import classnames from 'classnames';
import { toast } from 'react-toastify';
import { useAuth } from '../../helpers/hooks';
import { authAPI } from '../../helpers/api';

const Settings: React.FC = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('1');
  const [submitting, setSubmitting] = useState(false);

  // Profil Güncelleme
  const [profileData, setProfileData] = useState({
    firstName: user?.firstName || '',
    lastName: user?.lastName || '',
    email: user?.email || '',
  });

  // Şifre Değiştirme
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const handleProfileUpdate = async (e: React.FormEvent) => {
    e.preventDefault();
    toast.info('Profil güncelleme henüz aktif değil');
  };

  const handlePasswordChange = async (e: React.FormEvent) => {
    e.preventDefault();

    if (passwordData.newPassword !== passwordData.confirmPassword) {
      toast.error('Yeni şifreler eşleşmiyor');
      return;
    }

    if (passwordData.newPassword.length < 6) {
      toast.error('Şifre en az 6 karakter olmalı');
      return;
    }

    try {
      setSubmitting(true);
      await authAPI.changePassword({
        currentPassword: passwordData.currentPassword,
        newPassword: passwordData.newPassword,
      });
      toast.success('Şifre başarıyla değiştirildi');
      setPasswordData({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      });
    } catch (error: any) {
      toast.error(error.response?.data?.message || 'Şifre değiştirme başarısız');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Row>
        <Col xs={12}>
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">Ayarlar</h4>
          </div>
        </Col>
      </Row>

      <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                  <Nav tabs className="nav-tabs-custom nav-primary" style={{ flexWrap: 'nowrap' }}>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === '1' })}
                        onClick={() => setActiveTab('1')}
                        style={{ cursor: 'pointer' }}
                      >
                        <i className="ri-user-line me-1"></i>
                        Profil
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === '2' })}
                        onClick={() => setActiveTab('2')}
                        style={{ cursor: 'pointer' }}
                      >
                        <i className="ri-lock-line me-1"></i>
                        Şifre Değiştir
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>

                <TabContent activeTab={activeTab} className="pt-4">
                  {/* Profil Sekmesi */}
                  <TabPane tabId="1">
                    <Row>
                      <Col xs={12} lg={6}>
                        <Form onSubmit={handleProfileUpdate}>
                          <FormGroup>
                            <Label>Ad</Label>
                            <Input
                              type="text"
                              value={profileData.firstName}
                              onChange={(e) =>
                                setProfileData({ ...profileData, firstName: e.target.value })
                              }
                              disabled
                            />
                          </FormGroup>
                          <FormGroup>
                            <Label>Soyad</Label>
                            <Input
                              type="text"
                              value={profileData.lastName}
                              onChange={(e) =>
                                setProfileData({ ...profileData, lastName: e.target.value })
                              }
                              disabled
                            />
                          </FormGroup>
                          <FormGroup>
                            <Label>E-posta</Label>
                            <Input
                              type="email"
                              value={profileData.email}
                              disabled
                            />
                            <small className="text-muted">
                              E-posta değişikliği için yöneticiyle iletişime geçin.
                            </small>
                          </FormGroup>
                          <FormGroup>
                            <Label>Rol</Label>
                            <Input
                              type="text"
                              value={user?.role?.displayName || '-'}
                              disabled
                            />
                          </FormGroup>
                        </Form>
                      </Col>
                    </Row>
                  </TabPane>

                  {/* Şifre Değiştir Sekmesi */}
                  <TabPane tabId="2">
                    <Row>
                      <Col xs={12} lg={6}>
                        <Form onSubmit={handlePasswordChange}>
                          <Alert color="info" className="mb-4">
                            <i className="ri-information-line me-2"></i>
                            Güvenliğiniz için şifrenizi düzenli olarak değiştirin.
                          </Alert>
                          <FormGroup>
                            <Label>Mevcut Şifre *</Label>
                            <Input
                              type="password"
                              value={passwordData.currentPassword}
                              onChange={(e) =>
                                setPasswordData({
                                  ...passwordData,
                                  currentPassword: e.target.value,
                                })
                              }
                              placeholder="Mevcut şifrenizi girin"
                              required
                            />
                          </FormGroup>
                          <FormGroup>
                            <Label>Yeni Şifre *</Label>
                            <Input
                              type="password"
                              value={passwordData.newPassword}
                              onChange={(e) =>
                                setPasswordData({
                                  ...passwordData,
                                  newPassword: e.target.value,
                                })
                              }
                              placeholder="En az 6 karakter"
                              required
                              minLength={6}
                            />
                          </FormGroup>
                          <FormGroup>
                            <Label>Yeni Şifre (Tekrar) *</Label>
                            <Input
                              type="password"
                              value={passwordData.confirmPassword}
                              onChange={(e) =>
                                setPasswordData({
                                  ...passwordData,
                                  confirmPassword: e.target.value,
                                })
                              }
                              placeholder="Yeni şifreyi tekrar girin"
                              required
                            />
                          </FormGroup>
                          <Button color="primary" type="submit" disabled={submitting}>
                            {submitting ? 'Değiştiriliyor...' : 'Şifreyi Değiştir'}
                          </Button>
                        </Form>
                      </Col>
                    </Row>
                  </TabPane>

                </TabContent>
              </CardBody>
            </Card>
          </Col>
      </Row>
    </>
  );
};

export default Settings;
